import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import AudiencesInfoSection from '../../../../../../../ReusableFormFields/Audiences/AudiencesFields/AudiencesInfoSection'
import AudienceSelectionRadioBlocks from '../../../../../../../ReusableFormFields/Audiences/AudiencesFields/AudienceSelectionRadioBlocks'
import Spoiler from '../../../../../../../../components/Spoiler'
import AdvancedAudienceTargetingSection from './AdvancedAudienceTargetingSection'

import { hasTouchedErrors } from '../../../../../../../../helpers/errors'

import { audiencesLoadingSelector } from '../../../../../../../../modules/selectors/audiences'

import { CUSTOM_AGE_RANGES } from '../../../../../../../ReusableFormFields/AgeRangesFields/fields'

const formFields = [CUSTOM_AGE_RANGES]

const Dv360AdvancedAudienceFields = ({ formik, formattedAudiences }) => {
  const { t } = useTranslation()

  const audiencesIsLoading = useSelector(audiencesLoadingSelector)

  const { errors, touched } = formik

  const hasAdvancedAudienceTargetingError = hasTouchedErrors({
    formFields,
    errors,
    touched
  })

  return (
    <>
      <AudiencesInfoSection targetAudiencesText="Target one or more audiences" />
      <AudienceSelectionRadioBlocks
        formik={formik}
        audiencesIsLoading={audiencesIsLoading}
        formattedAudiences={formattedAudiences}
      />
      <Spoiler title={t('View more custom audience options')} triggerOpen={hasAdvancedAudienceTargetingError}>
        <AdvancedAudienceTargetingSection
          formik={formik}
          audiencesIsLoading={audiencesIsLoading}
          formattedAudiences={formattedAudiences}
        />
      </Spoiler>
    </>
  )
}

Dv360AdvancedAudienceFields.propTypes = {
  formik: PropTypes.object.isRequired,
  formattedAudiences: PropTypes.array.isRequired
}

export default Dv360AdvancedAudienceFields
